import styled from 'styled-components';

export const Div = styled.div``;
Div.displayName = `Hoverable.Div`;
